// import dayjs from 'dayjs';

// import api
import { getWorkLogMainStdInfo, getMissingInfo } from '@/api/workLog';
import { getCommonCode } from '@/api/code';

const workLog = {
  namespaced: 'WORK_LOG',

  state: {
    workLogStd: {},
    formItemList: [], // 기본폼

    missingInfo: {},
    feedbackObjList: [],

    viewFuncType: 'Z', // 업무일지 조회및열람 기능 사용 플래그 (*제외자때문에 추가 / Z: 기본, Y: 제외자조회가능, N: 제외자조회불가)
  },
  getters: {
    GET_WORK_LOG_STD(state) {
      return state.workLogStd;
    },
    GET_FORM_ITEM_LIST(state) {
      return state.formItemList;
    },
    GET_FEEDBACK_OBJ_LIST(state) {
      return state.feedbackObjList;
    },
    GET_VIEW_FUNC_TYPE(state) {
      return state.viewFuncType;
    },
  },
  mutations: {
    SET_WORK_LOG_STD(state, data) {
      state.workLogStd = data;
    },

    SET_FORM_ITEM_LIST(state, data) {
      state.formItemList = data;
    },

    SET_FEEDBACK_OBJ_LIST(state, data) {
      state.feedbackObjList = data;
    },

    SET_VIEW_FUNC_TYPE(state, data) {
      state.viewFuncType = data;
    },
  },
  actions: {
    /** 업무일지 기준정보 조회 */
    async FETCH_GET_WORK_LOG_STD({ commit }) {
      const response = await getWorkLogMainStdInfo();
      commit('SET_WORK_LOG_STD', response.data.data.stdInfo);
      commit('SET_FORM_ITEM_LIST', response.data.data.defaultForm);
    },

    /** 미작성 업무일지 건수 */
    async FETCH_MISSING_INFO({ commit }) {
      const response = await getMissingInfo();
      commit('SET_VIEW_FUNC_TYPE', response.data.data.viewFuncType);
      return response.data.data;
    },

    /** 피드백 선택형목록 조회 */
    async FETCH_FEEDBACK_OBJ_LIST({ commit }) {
      var grpCd = "'Z70030'";
      const response = await getCommonCode({ grpCd: grpCd });
      commit('SET_FEEDBACK_OBJ_LIST', response.data.data);
    },
  },
};

export default workLog;
